var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{staticClass:"form-select me-4 py-1",attrs:{"options":_vm.pageSizeOption},on:{"change":_vm.handleChange},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }